
      window["APP_BUILD_INFO"] ||= {};
      window["APP_BUILD_INFO"]["contact-us"] = {"build_base_commit_hash":"45c68f37cd365cbcd8734854c1a4ff992b9c996f","build_branch":"release_train_1195857640194","build_pub_date":"2026-08-04 17:25:52","build_version":"2.0.0.725"};
    